"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxGroupComponent = CheckboxGroup;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _checkbox = require("./checkbox");
var _fieldset = _interopRequireDefault(require("./fieldset"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var propTypes = {
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  fieldValidation: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].string,
    onBlur: _propTypes["default"].func,
    onChange: _propTypes["default"].func
  }),
  groupDescription: _propTypes["default"].string.isRequired,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
    name: _propTypes["default"].string.isRequired,
    dataTestId: _propTypes["default"].string,
    analyticsId: _propTypes["default"].string,
    isDisabled: _propTypes["default"].bool,
    isChecked: _propTypes["default"].bool,
    count: _propTypes["default"].number.isRequired,
    onChange: _propTypes["default"].func
  }).isRequired).isRequired,
  onChangeCallback: _propTypes["default"].func,
  stack: _propTypes["default"].bool
};
var defaultProps = {
  className: '',
  dataTestId: undefined,
  error: null,
  fieldValidation: undefined,
  onChangeCallback: function onChangeCallback() {},
  stack: false
};
var CountStyled = _styledComponents["default"].span.withConfig({
  displayName: "checkboxgroup__CountStyled",
  componentId: "sc-11ticv9-0"
})(["padding-left:var(--spacing-global-space3);"]);
function CheckboxGroup(_ref) {
  var className = _ref.className,
    groupTestId = _ref.dataTestId,
    error = _ref.error,
    fieldValidation = _ref.fieldValidation,
    groupDescription = _ref.groupDescription,
    items = _ref.items,
    onChangeCallback = _ref.onChangeCallback,
    stack = _ref.stack;
  return /*#__PURE__*/_react["default"].createElement(_fieldset["default"], {
    className: "fuse-checkbox-group ".concat(className),
    dataTestId: groupTestId,
    fieldValidation: fieldValidation,
    onChangeCallback: onChangeCallback,
    legend: groupDescription
  }, items.map(function (_ref2) {
    var label = _ref2.label,
      name = _ref2.name,
      value = _ref2.value,
      isDisabled = _ref2.isDisabled,
      isChecked = _ref2.isChecked,
      analyticsId = _ref2.analyticsId,
      dataTestId = _ref2.dataTestId,
      count = _ref2.count,
      onChange = _ref2.onChange;
    return /*#__PURE__*/_react["default"].createElement(_checkbox.Checkbox, {
      error: !!error,
      label: label,
      name: name,
      key: name,
      value: value,
      isDisabled: isDisabled,
      isChecked: isChecked,
      analyticsId: analyticsId,
      dataTestId: dataTestId,
      className: className,
      stack: stack,
      onChange: onChange
    }, /*#__PURE__*/_react["default"].createElement("span", null, label), /*#__PURE__*/_react["default"].createElement(CountStyled, null, count));
  }));
}
CheckboxGroup.propTypes = propTypes;
CheckboxGroup.defaultProps = defaultProps;
var _default = exports["default"] = CheckboxGroup;